// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__kXlYa","heading":"Footer_heading__0CJ+E","accodiance":"Footer_accodiance__LtjTP","question":"Footer_question__NVtGI","answer":"Footer_answer__YZahv"};